import React from 'react';
import PropTypes from 'prop-types';

/**
 * THIRDPARTY IMPORTS
 */
import { Menu, Layout } from 'antd';
import { Link } from 'react-router-dom';

import './WIHeader.css';

const { Header } = Layout;

export default class WIHeader extends React.Component {
  static propTypes = {
    /**
     * location Object from react-router-dom Router instance
     * @param string hash
     * @param string key
     * @param string pathname
     * @param string search
     * @param {} || undefined state
     */
    location: PropTypes.object.isRequired,
    navData: PropTypes.array
  };

  render() {
    const { location, navData } = this.props;
    return (
      <Header
        style={{
          overflow: 'hidden'
        }}
      >
        <div className="logo">
          <img
            src="/assets/WorldInsightErlebnisreisen_white.svg"
            style={{
              width: 150,
              height: 50
            }}
            alt="World Insight"
          />
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname.split('/')[1]]}
          style={{ lineHeight: '64px' }}
        >
          {navData.map(main => {
            return (
              <Menu.Item key={`${main.name}`}>
                {main.redirect ? (
                  <a
                    href={main.target_url}
                    aria-label={main.name}
                    title={main.name}
                  >
                    {main.title}
                  </a>
                ) : (
                  <Link to={`/${main.name}`} aria-label={main.name}>
                    {main.title}
                  </Link>
                )}
              </Menu.Item>
            );
          })}
        </Menu>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WIHeader/index.js